import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBulmaComponent } from './simple-icons-bulma.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBulmaComponent ],
    exports:      [ SimpleIconsBulmaComponent ],
    bootstrap:    []
})
export class SimpleIconsBulmaModule {}
